import React, { Component } from "react";
import styles from "./TodoIcon.module.scss";
import TodoList from "../TodoList";
export default class TodoIcon extends Component {
  constructor(props) {
    super(props);
    this.toggleShowTodo = () => {
      const {
        showTodoList
      } = this.state;
      this.setState({
        showTodoList: !showTodoList
      });
    };
    this.state = {
      showTodoList: false
    };
  }
  render() {
    const {
      showTodoList
    } = this.state;
    const {
      fetchUserTodos,
      addTodo,
      todos,
      todoLoading,
      apiBaseUrl
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles.notesIcon, " icon-notes"),
      role: "button",
      tabIndex: 0,
      onClick: this.toggleShowTodo
    }), showTodoList && /*#__PURE__*/React.createElement(TodoList, {
      apiBaseUrl: apiBaseUrl,
      toggleShowTodo: this.toggleShowTodo,
      fetchUserTodos: fetchUserTodos,
      addTodo: addTodo,
      userTodos: todos,
      todoLoading: todoLoading
    }));
  }
}